<script>
import { mapActions } from 'vuex';
import { PaymentMethodOptions } from '@/enums/paymentMethods';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Marathons'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Marathons'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'number', width: '130px' },
                { value: 'name', width: '200px' },

                {
                    value: 'teacher.fullName',
                    sortFieldName: 'teacher.firstName',
                    text: 'Teacher',
                    width: '150px'
                },

                {
                    value: 'campuses',
                    width: '250px',
                    filterFieldName: 'campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },

                {
                    value: 'price',
                    type: 'number',
                    filter: 'formatPrice',
                    width: '130px'
                },
                {
                    value: 'agudaPrice',
                    type: 'number',
                    filter: 'formatPrice',
                    width: '130px'
                },
                { value: 'limit', type: 'number', width: '130px' },
                {
                    value: 'availableSeats',
                    type: 'number',
                    width: '130px',
                    sortable: false
                },
                {
                    value: 'openingDate',
                    type: 'date',
                    width: '150px',
                    filter: 'formatDate'
                },
                {
                    value: 'terminal',
                    width: '180px',
                    type: 'enum',
                    enumOptions: PaymentMethodOptions,
                    isEnumOptionLabeled: true,
                    filter: 'terminal'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'courses/index',
            deleteItem: 'courses/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/courses/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/courses/add');
        }
    }
};
</script>
